module.exports = __webpack_public_path__ + "static/media/ahti_lohk.715167d7.jpg";